import jQuery from 'jquery';
import './style.scss';

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import visitAShowroom from './routes/visitAShowroom';
import 'bootstrap';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** Visit Showroom page, note the change from slug visit-a-showroom to visitAShowroom. */
  visitAShowroom
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./src/index.js